module.exports = __webpack_public_path__ + "static/img/EG.4e1e897.4e1e8970.jpg";